export default [
    {
        label: 'Organizations & Websites',
        description: 'Set up limitless websites within your organization, and manage multiple organizations in a single account.',
        route: {name: 'organizations'},
        icon: 'company',
    },
    {
        label: 'Shipping Zones',
        description: 'Configure shipping rates to any country by grouping them to shipping zones.',
        route: {name: 'shipping-zones'},
        icon: 'shipping',
    },
    {
        label: 'Custom Fields',
        description: 'Add custom fields to checkout forms to store information specific to your business’s needs.',
        route: {name: 'custom-fields'},
        icon: 'custom-fields',
    },
    {
        label: 'Product & Pricing Plans',
        description: 'Products are the items that your business sells, and pricing plans are how your customers pay for that item.',
        route: {name: 'products'},
        icon: 'product',
    },
    {
        label: 'Checkout Pages',
        description: 'Quickly create pages to accept payments from your customers and customize them to match your brand.',
        route: {name: 'checkout-pages'},
        icon: 'logout',
    },
    {
        label: 'Tags',
        description: 'Create tags for customers.',
        route: {name: 'tags'},
        icon: 'tag',
    },
    {
        label: 'Users',
        description: 'Create individual credentials that other team members can use to log in.',
        route: {name: 'users'},
        icon: 'users',
    },
    {
        label: 'Segments',
        description: 'Manage segments to define the data in your lists.',
        route: {name: 'segments'},
        icon: 'segments',
    },
    {
        label: 'Gateway Accounts',
        description: 'Configure your gateway accounts to begin accepting authorized payments through Rebilly.',
        route: {name: 'gateway-accounts'},
        icon: 'bank',
    },
    {
        label: 'Coupons',
        description: 'Create coupons to apply discounts to your invoices and plans, from a one-time use coupon to a lifetime discount.',
        route: {name: 'coupons'},
        icon: 'coupon',
    },
];
